<template>
  <div>
    <horizontal-navbar></horizontal-navbar>
    <breadcrumb-slot class="pt-2 pb-2" :items="items" :modal="false"></breadcrumb-slot>

    <div class="pt-1 pb-3 d-flex justify-content-between align-items-center">
      <div v-if="patientInfoVisible" class="d-flex flex-column align-items-start">
        <h2 class="text-dark">
          {{ patient_info.firstName }} {{ patient_info.lastName }}
          <small> {{ new Date(patient_info.createDate).toLocaleString() }}</small>
        </h2>
        <p v-if="patient_info.creatorUser">
          დაამატა: {{ patient_info.creatorUser.firstName }} {{ patient_info.creatorUser.lastName }}
        </p>
      </div>

      <b-button variant="flat-danger" class="" @click="deletePatient($route.params.id)">
        <feather-icon icon="Trash2Icon"
                      class="mr-50"/>
        <span class="align-middle">პაციენტის წაშლა</span>
      </b-button>
    </div>

    <b-tabs pills>
      <b-tab active title="დეტალები">

        <b-card class="about-patient-container">
          <div class="table-header d-flex align-items-center justify-content-between">
            <h3 class="text-dark mb-0">კონტაქტის შესახებ</h3>

            <div class="d-flex justify-content-end">
              <b-button variant="secondary" class="btn-icon mr-1" @click="editProfile">
                <feather-icon icon="Edit3Icon"/>
              </b-button>
              <b-button variant="secondary" class="toggle-button btn-icon" @click="togglePatientInfo">
                <feather-icon :class="{'rotate': !patientInfoVisible}" icon="ChevronUpIcon"/>
              </b-button>
            </div>

          </div>

          <template v-if="patientInfoVisible">
            <div class="infos mt-2">
              <div class="info-container">
                <span>პირადი ნომერი:</span>
                <span><strong>{{ patient_info.identityNumber }}</strong></span>
              </div>

              <div class="info-container">
                <span>სქესი:</span>
                <span><strong>{{ gender }}</strong></span>
              </div>

              <div class="info-container">
                <span>ტელეფონის ნომერი:</span>
                <span><strong>{{ patient_info.phoneNumber }}</strong></span>
              </div>

              <div class="info-container">
                <span>დაბადების თარიღი:</span>
                <span><strong>{{ formatDate(patient_info.birthDate) }}</strong></span>
              </div>

              <div class="info-container">
                <span>რეგიონი:</span>
                <span><strong>{{ patient_info.address.region }}</strong></span>
              </div>

              <div class="info-container">
                <span>ალტერნატიული ტელეფონის ნომერი:</span>
                <span><strong>{{ patient_info.alternamePhoneNumber }}</strong></span>
              </div>

              <div class="info-container">
                <span>მისამართი:</span>
                <span><strong>{{ patient_info.address.address }}</strong></span>
              </div>

              <div class="info-container">
                <span>ასაკი:</span>
                <span><strong>{{ patient_info.age }}</strong></span>
              </div>

              <div class="info-container">
                <span>ქალაქი/რაიონი:</span>
                <span><strong>{{ patient_info.address.city }}</strong></span>
              </div>


            </div>

            <div class="divider my-2">
              <div class="divider-text">
                ინდექს პაციენტი
              </div>
            </div>

            <div class="infos index-patients">
              <div class="info-container">
                <span>ინდექს პაციენტი:</span>
                <span v-if="patient_info.indexPatient"><strong>
                  {{ patient_info.indexPatient.firstName }} {{ patient_info.indexPatient.lastName }}
                </strong></span>
              </div>

              <div class="info-container">
                <span>ტუბ. შემთხვევის კოდი:</span>
                <span v-if="patient_info.indexPatient"><strong>{{
                    patient_info.indexPatient.latestCaseCode
                  }}</strong></span>
              </div>

              <div class="info-container">
                <span>პირადი ნომერი:</span>
                <span v-if="patient_info.indexPatient"><strong>{{ patient_info.indexPatient.identityNumber }}0</strong></span>
              </div>

            </div>
          </template>
        </b-card>

        <b-card class="risk-factors-container">
          <div class="table-header d-flex align-items-center justify-content-between">
            <h3 class="text-dark mb-0">რისკ-ჯგუფები და სიმპტომები</h3>

            <b-button variant="secondary" class="toggle-button btn-icon" @click="toggleSymptoms">
              <feather-icon :class="{'rotate': !symptomsVisible}" icon="ChevronUpIcon"/>
            </b-button>
          </div>

          <div v-if="symptomsVisible" class="responsibility-container pt-1 mt-4">
            <div class="info-container d-flex ">
              <span>ფაქტორები:</span>
              <div class="badges pt-1">
                <b-badge v-for="risk in patient_info.riskGroups" v-bind:key="risk.id"
                         class="badge-light-dark p-1">
                  {{ risk.title }}
                </b-badge>
              </div>
            </div>
            <div class="info-container d-flex">
              <span>პირველადი სიმპტომები:</span>
              <div class="badges pt-1">
                <b-badge v-for="symptom in patient_info.symptoms" v-bind:key="symptom.id"
                         class="badge-light-dark p-1">
                  {{ symptom.title }}
                </b-badge>
              </div>
            </div>
          </div>
        </b-card>

        <b-card v-if="patient_researches" class="analysis">

          <div class="table-header d-flex align-items-center justify-content-between">
            <h3 class="text-dark mb-0">კვლევის შედეგები</h3>

            <div class="d-flex justify-content-end">
              <b-button variant="secondary" class="toggle-button btn-icon" @click="toggleAnalysis">
                <feather-icon :class="{'rotate': !analysisVisible}" icon="ChevronUpIcon"/>
              </b-button>
            </div>

          </div>

          <template v-if="analysisVisible">
            <div class="divider my-2 pt-2 mt-2 ">
              <div class="divider-text">
                კვლევა აქტიურ ტუბერკულოზზე
              </div>
            </div>

            <div class="infos" v-if="Object.keys(patient_researches.tb).length > 0">
              <div class="info-container">
                <span>მომართვის თარიღი:</span>
                <span>
                  <strong>{{ formatDate(patient_researches['tb'].issueDate) }}</strong>
                </span>
              </div>

              <div class="info-container">
                <span>ჩატარების თარიღი:</span>
                <span>
                  <strong>{{ formatDate(patient_researches['tb'].researchDate) }}</strong>
                </span>
              </div>

              <div class="info-container">
                <span>კვლევის შედეგი:</span>
                <span><strong>{{ patient_researches['tb'].researchMethodResult }}</strong></span>
              </div>

              <div class="info-container">
                <span>რეზისტენტობა:</span>
                <span>
                  <strong>{{ formatDate(patient_researches['tb'].resistance) }}</strong>
                </span>
              </div>

              <div class="info-container">
                <span>ტუბ. ლოკალიზაცია:</span>
                <span><strong>{{ patient_researches['tb'].tbLocalization }}</strong></span>
              </div>

              <div class="info-container">
                <span>TB კვლევის პასუხი:</span>
                <span><strong>{{
                    patient_researches['tb'].confirmed !== null && (patient_researches['tb'].confirmed === true ? 'დადასტურდა' : 'არ დადასტურდა')
                  }}</strong></span>
              </div>

            </div>

            <empty-state v-else text="კვლევებზე ინფორმაცია არ არის"></empty-state>

            <div class="divider my-2">
              <div class="divider-text">
                კვლევა ტუბერკულოზურ ინფექციაზე
              </div>
            </div>

            <div class="infos" v-if="Object.keys(patient_researches.tbi).length > 0">
              <div class="info-container">
                <span>მომართვის თარიღი:</span>
                <span><strong>{{ formatDate(patient_researches['tbi'].issueDate) }}</strong></span>
              </div>

              <div class="info-container">
                <span>კვლევის მეთოდი:</span>
                <span><strong>{{ patient_researches['tbi'].researchMethod }}</strong></span>
              </div>

              <div class="info-container">
                <span>მკურნალობის შეთავაზება:</span>
                <span><strong>{{ patient_researches['tbi'].treatmentSuggestion }}</strong></span>
              </div>

              <div class="info-container">
                <span>ჩატარების თარიღი:</span>
                <span><strong>{{ formatDate(patient_researches['tbi'].researchDate) }}</strong></span>
              </div>

              <div class="info-container">
                <span>კვლევის შედეგი:</span>
                <span><strong>{{ patient_researches['tbi'].researchMethodResult }}</strong></span>
              </div>

              <div class="info-container">
                <span>თანხმობა მკურნალობაზე:</span>
                <span><strong>{{ patient_researches['tbi'].treatmentSuggestionAnswer }}</strong></span>
              </div>

              <div class="info-container">
                <span>TBI კვლევის პასუხი:</span>
                <span><strong>{{
                    patient_researches['tbi'].confirmed !== null && (patient_researches['tbi'].confirmed === true ? 'დადასტურდა' : 'არ დადასტურდა')
                  }}</strong></span>
              </div>

            </div>

            <empty-state v-else text="კვლევებზე ინფორმაცია არ არის"></empty-state>
          </template>

        </b-card>

        <b-card>
          <div class="table-header d-flex align-items-center justify-content-between">
            <h3 class="text-dark mb-0">პასუხისმგებელი პირი და დაწესებულებები</h3>

            <b-button variant="secondary" class="toggle-button btn-icon" @click="toggleResponsiblePerson">
              <feather-icon :class="{'rotate': !responsiblePersonVisible}" icon="ChevronUpIcon"/>
            </b-button>
          </div>

          <div v-if="responsiblePersonVisible" class="responsibility-container align-items-start  pt-2 pb-2">
            <div class="info-container">
              <span>პაციენტი დაარეგისტრირა:</span>
              <span><strong>{{ patient_info.responsiblePerson }}</strong></span>
            </div>
            <div class="d-flex flex-column ">
              <span>პროფილზე წვდომის მქონე დაწესებულებები:</span>
              <div class="badges pt-1">
                <b-badge v-for="institution in patient_info.institutions" v-bind:key="institution.id"
                         class="badge-light-dark p-1 mr-1">{{ institution.title }}
                </b-badge>

              </div>
            </div>
          </div>
        </b-card>

      </b-tab>

      <b-tab title="მიდევნება">
        <template v-if="followups && followups.length > 0">
          <b-card v-for="followup in followups" v-bind:key="followup.id"
                  class="analysis risk-factors-container mb-4">
            <div class="table-header pb-2 d-flex align-items-center justify-content-between">
              <h3 class="text-dark">მიდევნება {{ followup.id }}</h3>

              <b-button variant="btn-icon primary" class="">
                <feather-icon icon="ChevronUpIcon"
                              class="mr-50"/>
              </b-button>
            </div>

            <div class="current-case mb-3">

              <div class="info-container">
                <span>მიდევნების თარიღი (რეკომენდებული):</span>
                <span><strong>{{ formatDate(followup.recommendedDate) }}</strong></span>
              </div>

              <div class="info-container">
                <span>გადამისამართება:</span>
                <span><strong>{{ followup.institutionIds }}</strong></span>
              </div>

              <div class="info-container">
                <span>მიდევნების ჩატარების თარიღი:</span>
                <span><strong>{{ formatDate(followup.completeDate) }}</strong></span>
              </div>

              <div class="info-container">
                <span>კვლევების საჭიროება:</span>
                <span v-if="followup.requiresNextResearches"><strong>კი</strong></span>
                <span v-else><strong>არა</strong></span>
              </div>

            </div>

            <div class="responsibility-container mb-5 pb-3">
              <div class="info-container d-flex">
                <span>მიმდინარე სიმპტომები:</span>
                <div class="badges pt-1">
                  <b-badge v-for="symptom in followup.symptomIds" v-bind:key="symptom"
                           class="badge-light-dark p-1">{{ symptom }}
                  </b-badge>
                </div>
              </div>
            </div>

            <b-card class="analysis mb-4">

              <div class="divider my-2">
                <div class="divider-text">
                  კვლევა აქტიურ ტუბერკულოზზე
                </div>
              </div>

              <div class="infos" v-if="followup.tbResearch">
                <div class="info-container">
                  <span>საბოლოო შედეგი:</span>
                  <span><strong>{{ tbResearch.tbConfirmed }}</strong></span>
                </div>
              </div>

              <empty-state v-else text="კვლევებზე ინფორმაცია არ არის"></empty-state>

              <div class="divider my-2">
                <div class="divider-text">
                  კვლევა ტუბერკულოზურ ინფექციაზე
                </div>
              </div>

              <div class="infos" v-if="followup.tbiResearch">
                <div class="info-container">
                  <span>მომართვის თარიღი:</span>
                  <span><strong>{{ formatDate(followup.tbResearch.issueDate) }}</strong></span>
                </div>

                <div class="info-container">
                  <span>კვლევის მეთოდი:</span>
                  <span><strong>{{ followup.tbResearch.researches[0].researchMethodTitle }}</strong></span>
                </div>

                <div class="info-container">
                  <span>მკურნალობის შეთავაზება:</span>
                  <span><strong>{{ followup.tbResearch.treatmentSuggestion }}</strong></span>
                </div>

                <div class="info-container">
                  <span>ჩატარების თარიღი:</span>
                  <span><strong>{{ formatDate(followup.tbResearch.researchDate) }}</strong></span>
                </div>

                <div class="info-container">
                  <span>საბოლოო დიაგნოზი:</span>
                  <span><strong>{{ followup.tbResearch.tbConfirmed }}</strong></span>
                </div>

                <div class="info-container">
                  <span>თანხმობა მკურნალობაზე:</span>
                  <span><strong>{{ followup.tbResearch.treatmentSuggestionAnswer }}</strong></span>
                </div>

              </div>

              <empty-state v-else text="კვლევებზე ინფორმაცია არ არის"></empty-state>


            </b-card>

          </b-card>
        </template>

        <empty-state v-else color="white" text="მიდევნება არ არის დამატებული"></empty-state>

      </b-tab>

      <b-tab title="მკურნალობები">

        <template v-if="treatments && treatments.length > 0">
          <b-card v-for="treatment in treatments" v-bind:key="tkeys[treatment.id]"
                  :class="{'finished-treatment' : treatment.completed}"
                  class="analysis risk-factors-container mb-4">
            <div class="table-header pb-2 d-flex align-items-center justify-content-between">
              <h3 v-if="!treatment.completed" class="text-dark">მიმდინარე მკურნალობა</h3>

              <h3 v-else class="text-dark">
                დასრულებული მკურნალობა
                <span class="small">
                                {{ formatDate(treatment.treatmentStartDate) }} - 24.12.2019
                            </span>
              </h3>

              <b-button variant="btn-icon primary" class="">
                <feather-icon icon="ChevronUpIcon"
                              class="mr-50"/>
              </b-button>
            </div>

            <div class="current-case mb-3">

              <div class="info-container">
                <span>მკურნალი ექიმი:</span>
                <span><strong>{{ treatment.doctor }}</strong></span>
              </div>

              <div class="info-container">
                <span>მკურნალობის მხარდაჭერის ტიპი:</span>
                <span><strong>{{ treatment.treatmentSupportType }}</strong></span>
              </div>

              <div class="info-container">
                <span>მკურნალობაზე მყოფი პირის წონა</span>
                <span><strong>{{ treatment.patientWeight }}</strong></span>
              </div>

              <div class="info-container">
                <span>მკურნალობის დაწყების თარიღი:</span>
                <span><strong>{{ formatDate(treatment.treatmentStartDate) }}</strong></span>
              </div>

              <div class="info-container">
                <span>სამკურნალო რეჟიმი:</span>
                <span><strong>{{ treatment.treatment.title }}</strong></span>
              </div>

            </div>

            <p>გვერდითი მოვლენები</p>
            <b-table responsive="sm"
                     :fields="['title', 'issueDate']"
                     fixed outlined show-empty
                     empty-text="გვერდითი მოვლენები არ არის დამატებული"
                     :items="treatment.side_effects">

              <template #cell(side_effect)="data" td-class="text-right">
                <p class="mb-0"><strong>{{ data.item.title }}</strong></p>
              </template>

              <template #cell(issueDate)="data" td-class="text-right">
                <p class="mb-0">{{ formatDate(data.item.issueDate) }}</p>
              </template>
            </b-table>

            <p class="mt-4">ლაბორატორიული მონიტორინგი</p>
            <b-table responsive="sm"
                     :fields="['createDate', 'title']"
                     fixed outlined show-empty
                     empty-text="ლაბორატორიული მონიტორინგი არ არის დამატებული"
                     :items="treatment.laboratoryMonitorings">

              <template #cell(createDate)="data" td-class="text-right">
                <p class="mb-0">{{ formatDate(data.item.createDate) }}</p>
              </template>

              <template #cell(title)="data" td-class="text-right">
                <p class="mb-0 text-uppercase"><strong>{{ data.item.title }}</strong></p>
              </template>
            </b-table>
          </b-card>
        </template>

        <empty-state v-else color="white" text="მკურნალობა არ მიმდინარეობს"></empty-state>

      </b-tab>
    </b-tabs>

    <b-modal id="modal-edit"
             ref="my-modal"
             size="lg"
             class="p-3"
             hide-footer
             hide-header
             centered>

      <div class="pt-2 modal-custom-header d-flex align-items-center justify-content-between">
        <h4></h4>
        <b-button variant="flat-secondary" class="btn-icon" size="lg" @click="hideModal">
          <feather-icon icon="XIcon"/>
        </b-button>
      </div>
      <validation-observer ref="editIndexPatient" #default="{invalid}">

        <b-form>
          <div class="d-flex justify-content-between">
            <b-form-group class="name-wrapper mb-2 mt-2 w-75">
              <label for="name">სახელი და გვარი</label>
              <b-input-group class="input-group-merge flex-nowrap">
                <validation-provider
                    class="pr-2"
                    #default="{ errors }"
                    name="firstname"
                    vid="firstname"
                    rules="required">
                  <b-form-input class="mr-1"
                                :class="{'btn-outline-success': editingName}"
                                v-model="name"
                                id="name"
                                placeholder="სახელი"
                                type="text"></b-form-input>
                  <small class="text-danger pl-1">{{ errors[0] }}</small>
                </validation-provider>
                <validation-provider
                    class="w-50"
                    #default="{ errors }"
                    name="lastname"
                    vid="surname"
                    rules="required">
                  <b-form-input
                      :class="{'btn-outline-success': editingName}"
                      v-model="surname"
                      id="surname"
                      placeholder="გვარი"
                      type="text"></b-form-input>
                  <small class="text-danger pl-1">{{ errors[0] }}</small>
                </validation-provider>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="edit-patient d-flex row justify-content-between">
            <b-form-group label="პირადი ნომერი *"
                          label-for="id">
              <validation-provider
                  #default="{ errors }"
                  name="identity number"
                  vid="id"
                  rules="required|digits:11">
                <b-form-input id="id" v-model="identityNumber"
                              placeholder="პირადი ნომერი"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="ტელეფონის ნომერი *"
                          label-for="phone">
              <b-form-input id="phone" v-model="phone"
                            placeholder="ტელეფონის ნომერი"/>
            </b-form-group>
            <b-form-group label="ალტერნატიული ტელეფონის ნომერი"
                          label-for="phone">
              <b-form-input id="alternatePhoneNumber" v-model="alternatePhoneNumber"
                            placeholder="ალტერნატიული ტელეფონის ნომერი"/>
            </b-form-group>
            <b-form-group label="დაბადების თარიღი *"
                          label-for="birthDate">
              <flat-pickr
                  class="form-control"
                  v-model="birthDate"
                  :value="birthDate"
                  :config="{allowInput: true}"
              />
            </b-form-group>

            <b-form-group label="რეგიონი *"
                          label-for="region">
              <b-form-select v-model="selectedRegion"
                             :options="regions"/>
            </b-form-group>
            <b-form-group label="ასაკი *"
                          label-for="age">
              <b-form-input id="age" v-model="age"
                            placeholder="ასაკი"/>
            </b-form-group>
            <b-form-group label="ქალაქი/სოფელი *"
                          label-for="city">
              <b-form-input id="city" v-model="city"
                            placeholder="ქალაქი/სოფელი"/>
            </b-form-group>
            <b-form-group label="სქესი *"
                          label-for="gender">
              <b-form-select id="gender" v-model="selectedGender"
                             :options="genderOptions"/>
            </b-form-group>
            <b-form-group label="მისამართი *"
                          label-for="address">
              <b-form-input id="address" v-model="address"
                            placeholder="მისამართი"/>
            </b-form-group>
          </div>

          <template>
            <div class="divider my-2">
              <div class="divider-text">პასუხისმგებელი პირი და დაწესებულებები</div>
            </div>
            <div>
              <b-form-group label="პასუხისმგებელი პირი *"
                            label-for="responsiblePerson">
                <b-form-input id="responsiblePerson" v-model="responsiblePerson"
                              placeholder="პასუხისმგებელი პირი"/>
              </b-form-group>
              <b-form-group label="დაწესებულებები" v-if="institutions.length">
                <multiselect v-model="chosenInstitutions" tag-placeholder="საძიებო სიტყვა"
                             placeholder="ძიება" label="text" track-by="value"
                             :options="institutions" :multiple="true" :taggable="true"></multiselect>
              </b-form-group>
            </div>
          </template>

          <template>
            <div class="divider my-2">
              <div class="divider-text">რისკ ფაქტორები</div>
            </div>
            <b-form-group label="რისკ ჯგუფები" v-if="risk_factors.length">
              <multiselect v-model="riskFactorIds" tag-placeholder="საძიებო სიტყვა"
                           placeholder="რისკ ჯგუფები" label="text" track-by="value"
                           :options="risk_factors" :multiple="true" :taggable="true"></multiselect>
            </b-form-group>
          </template>

          <template>
            <div class="divider my-2">
              <div class="divider-text">სიმპტომები</div>
            </div>
            <b-form-group label="სიმპტომები" v-if="symptoms.length">
              <multiselect v-model="symptomIds" tag-placeholder="საძიებო სიტყვა"
                           placeholder="" label="text" track-by="value"
                           :options="symptoms" :multiple="true" :taggable="true"></multiselect>
            </b-form-group>
          </template>

          <div class="mt-3 d-flex justify-content-between align-items-center">
            <b-button :disabled="invalid" variant="primary" class="save-changes mb-3" @click="updateProfile">
              <feather-icon icon="SaveIcon"
                            class="mr-50"/>
              <span class="align-middle">ცვლილებების შენახვა</span>
            </b-button>
          </div>
        </b-form>

      </validation-observer>
    </b-modal>

  </div>
</template>

<script>
import BreadcrumbSlot from "../../components/breadcrumb/BreadcrumbSlot";
import flatPickr from "vue-flatpickr-component"
import {
  BButton,
  BCard,
  BBadge,
  BInputGroup,
  BFormGroup,
  BForm,
  BModal,
  BFormInput,
  BFormSelect,
  BTabs,
  BTab,
  BTable
} from "bootstrap-vue"
import modulePatients from "../../../store/patient/modulePatients"
import moduleTreatments from "../../../store/treatments/moduleTreatments"
import moduleRegions from "../../../store/regions/moduleRegions"
import EmptyState from "../../components/EmptyState";
import HorizontalNavbar from "../../navbar/HorizontalNavbar";
import moduleInstitutions from "@/store/institution/moduleInstitution";
import Multiselect from "vue-multiselect"
import moduleVariables from "@/store/variables/moduleVariables";
import {ValidationProvider, ValidationObserver} from "vee-validate"
import {required, digits} from "@validations"

export default {
  name: "ContactProfile",
  components: {
    Multiselect,
    HorizontalNavbar,
    EmptyState,
    // TableBasicPatients,
    BreadcrumbSlot,
    BCard,
    BBadge,
    BButton,
    BInputGroup,
    BFormGroup,
    BForm,
    BModal,
    BFormInput,
    flatPickr,
    BFormSelect,
    BTabs,
    BTab,
    BTable,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      // validation rules
      required,
      digits,

      tkeys: {},
      items: [
        {
          text: "კონტაქტები",
          link: "contacts",
          active: false
        },
        {
          text: "",
          active: true
        }
      ],
      months: {
        0: "იანვარი",
        1: "თებერვალი",
        2: "მარტი",
        3: "აპრილი",
        4: "მაისი",
        5: "ივნისი",
        6: "ივლისი",
        7: "აგვისტო",
        8: "სექტემბერი",
        9: "ოქტომბერი",
        10: "ნოემბერო",
        11: "დეკემბერი"
      },

      analyzesRows: [],
      editingName: false,
      name: "",
      surname: "",
      age: "",
      city: "",
      address: "",
      phone: "",
      identityNumber: "",
      responsiblePerson: "",
      alternatePhoneNumber: "",
      chosenInstitutions: [],
      riskFactorIds: [],
      symptomIds: [],
      selectedRegion: null,
      selectedGender: null,

      genderOptions: [
        {value: null, text: "აირჩიეთ სქესი"},
        {value: "Male", text: "მამრობითი"},
        {value: "Female", text: "მდედრობითი"},
        {value: "Other", text: "სხვა"},
      ],

      birthDate: null,

      date: null,
      config: {
        altFormat: "F j, Y",
        altInput: true
      },

      navItems: [],

      patientInfoVisible: true,
      symptomsVisible: true,
      analysisVisible: true,
      responsiblePersonVisible: true,
    }
  },

  computed: {

    patient_info() {
      return this.$store.state.patients.patient_info
    },

    patient_current_cases() {
      return this.$store.state.patients.patient_current_cases
    },

    patient_treatments() {
      return this.$store.state.patients.patient_treatments
    },

    patient_researches() {
      return this.$store.state.patients.patient_researches
    },

    patient_contacts() {
      return this.$store.state.patients.patient_contacts.length > 0 ? this.$store.state.patients.patient_contacts : []
    },

    treatments() {
      return this.$store.state.treatments.treatments
    },

    regions() {
      return this.$store.state.regions.regions
    },

    followups() {
      return this.$store.state.patients.followups
    },

    gender() {
      let genderObj = this.genderOptions.find(a => a.value === this.patient_info.gender)
      return genderObj ? genderObj.text : ""
    },

    institutions() {
      return this.$store.state.institution.institutions
    },

    risk_factors() {
      return this.$store.state.variables.all_risk_factors
    },

    symptoms() {
      return this.$store.state.variables.all_symptoms
    }
  },

  watch: {},

  created() {

    if (!modulePatients.isRegistered) {
      this.$store.registerModule("patients", modulePatients);
      modulePatients.isRegistered = true
    }

    if (!moduleTreatments.isRegistered) {
      this.$store.registerModule("treatments", moduleTreatments);
      moduleTreatments.isRegistered = true
    }

    if (!moduleRegions.isRegistered) {
      this.$store.registerModule("regions", moduleRegions);
      moduleRegions.isRegistered = true
    }

    if (!moduleInstitutions.isRegistered) {
      this.$store.registerModule("institution", moduleInstitutions);
      moduleInstitutions.isRegistered = true
    }

    if (!moduleVariables.isRegistered) {
      this.$store.registerModule("variables", moduleVariables);
      moduleVariables.isRegistered = true
    }

    this.getContactInfo(this.$route.params.id).then(() => {
      this.items[1].text = this.patient_info.firstName + " " + this.patient_info.lastName
    });

    this.getContactResearches(this.$route.params.id);

    this.getTreatments(this.$route.params.id).then(() => {
      this.treatments.forEach((t, i) => {
        this.tkeys[t.id] = i;
        this.getPatientSideEffects({patient_id: this.$route.params.id, treatment_id: t.id}).then(() => {
          this.tkeys[t.id] = t.id;
        });
      })
    });

    this.getPatientFollowups(this.$route.params.id);

    this.getRegions();

    this.getInstitutions({take: -1, skip: 0}).then(() => {
      // this.patient_info.institutions.forEach(item => {
      //   this.chosenInstitutions = {
      //     text: item.title,
      //     value: item.id
      //   }
      // })
    })
    // this.getIndexPatientCurrentCases(this.$route.params.id);

    // this.getIndexPatientContacts(this.$route.params.id);
  },

  mounted() {
    this.navItems = document.getElementsByClassName("nav-item");
    this.navItems[19].classList.add("active");
  },

  methods: {

    getRegions(payload = {}) {
      // this.tableVisible = false;
      return this.$store.dispatch("regions/getRegions", payload).then(() => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    getPatientFollowups(id) {
      // this.tableVisible = false;
      return this.$store.dispatch("patients/getPatientFollowups", {id: id}).then(() => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    getTreatments(id) {
      return this.$store.dispatch("treatments/getTreatments", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    getInstitutions(payload = {}) {
      // this.tableVisible = false;
      return this.$store.dispatch("institution/getInstitutions", payload).then((response) => {
        // this.tableVisible = true;
      }).catch((err) => {
      });
    },

    updateContactInfo(payload) {
      return this.$store.dispatch("patients/updateContactInfo", payload).then(() => {
        this.getContactInfo(this.$route.params.id);
        this.hideModal();
      }).catch((err) => {
      });
    },

    getContactInfo(id) {
      return this.$store.dispatch("patients/getContactInfo", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    getRiskFactors(payload = {}) {
      return this.$store.dispatch("variables/getRiskFactors", payload).then(() => {
      }).catch((err) => {
      });
    },

    getSymptoms(payload = {}) {
      return this.$store.dispatch("variables/getSymptoms", payload).then(() => {
      }).catch((err) => {
      });
    },

    getContactResearches(id) {
      return this.$store.dispatch("patients/getContactResearches", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    getContactTreatments(id) {
      return this.$store.dispatch("patients/getContactTreatments", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    getIndexPatientCurrentCases(id) {
      return this.$store.dispatch("patients/getIndexPatientCurrentCases", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    getIndexPatientContacts(id) {
      return this.$store.dispatch("patients/getIndexPatientContacts", {id: id}).then(() => {
      }).catch((err) => {
      });
    },

    getPatientSideEffects(payload) {
      return this.$store.dispatch("treatments/getPatientSideEffects", payload).then(() => {
      }).catch((err) => {
      });
    },

    updateProfile() {
      let profile = {
        "id": this.$route.params.id,
        "birthDate": new Date(this.birthDate),
        "age": this.age,
        "gender": this.selectedGender,
        "firstName": this.name,
        "lastName": this.surname,
        "identityNumber": this.identityNumber,
        "phoneNumber": this.phone,
        "institutionIds": this.chosenInstitutions.map(el => el.value),
        "riskFactorIds": this.riskFactorIds?.map(el => el.value),
        "symptomIds": this.symptomIds?.map(el => el.value),
        "responsiblePerson": this.responsiblePerson,
        "alternamePhoneNumber": this.alternatePhoneNumber,
        "address": {
          "city": this.city,
          "address": this.address,
          "id": this.patient_info.address.id,
          "regionId": this.selectedRegion
        }
      };

      this.updateContactInfo(profile);
    },

    editProfile() {
      this.getRiskFactors().then(() => {
        this.getSymptoms();
        this.name = this.patient_info.firstName;
        this.surname = this.patient_info.lastName;
        this.age = this.patient_info.age;
        this.city = this.patient_info.address.city;
        this.address = this.patient_info.address.address;
        this.phone = this.patient_info.phoneNumber;
        this.birthDate = this.patient_info.birthDate;
        this.selectedGender = this.patient_info.gender;
        this.selectedRegion = this.patient_info.address.regionId;
        this.identityNumber = this.patient_info.identityNumber;
        this.riskFactorIds = this.patient_info.riskGroups.map((el) => {
          return {text: el.title, value: el.id}
        })
        this.symptomIds = this.patient_info.symptoms.map((el) => {
          return {text: el.title, value: el.id}
        })
        this.responsiblePerson = this.responsiblePerson ? this.responsiblePerson : this.patient_info.responsiblePerson;
        this.alternatePhoneNumber = this.alternatePhoneNumber ? this.alternatePhoneNumber : this.patient_info.alternamePhoneNumber;
        this.chosenInstitutions = this.patient_info.institutions.map((el) => {
          return {text: el.title, value: el.id}
        })
        this.$refs["my-modal"].show()
      })
    },

    deletePatient(id) {
      this.$swal({
        title: "<span class=\"font-medium-1\">დარწმუნებული ხარ რომ გსურს წაშლა?</span>",
        icon: "warning",
        html:
            "<span class=\"font-small-3\">წაშლის შემდეგ ინფორმაციის აღდგენა შეუძლებელია</span>",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "დიახ წაშალე",
        cancelButtonText: "გაუქმება",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((value) => {
        if (value.isConfirmed) {
          this.$store.dispatch("patients/deletePatient", id).then(() => {
            this.$router.push({name: "contacts"})
          }).catch((err) => {
          });
        }
      });
    },

    formatDate(date) {
      if (date) {
        let d = new Date(date);
        let day = d.getDate();
        let monthName = this.months[d.getMonth()];
        let year = d.getFullYear();
        return `${day} ${monthName}, ${year}`;
      }
      return ""
    },

    hideModal() {
      this.$refs["my-modal"].hide()
    },

    togglePatientInfo() {
      this.patientInfoVisible = !this.patientInfoVisible
    },

    toggleSymptoms() {
      this.symptomsVisible = !this.symptomsVisible
    },

    toggleAnalysis() {
      this.analysisVisible = !this.analysisVisible
    },

    toggleResponsiblePerson() {
      this.responsiblePersonVisible = !this.responsiblePersonVisible
    },
  },

  destroyed() {
    this.navItems[19].classList.remove("active");
  }

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';


.toggle-button {
  svg {
    transition: 0.2s all ease;
  }

  .rotate {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}


.save-changes.btn span {
  font-size: 16px;
}

.form-group label {
  font-size: 1.057rem;
}

.modal-custom-header h4 {
  font-size: 20px;
}

.infos {
  display: grid;
  grid-template-columns: 2fr 2fr 3fr;
  grid-gap: 10px;
}

.current-case {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.responsibility-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
}

.risk-factors-container {
  .info-container {
    height: auto;
  }
}

.info-container {
  height: 3.5vh;
  margin-right: 2vw;
  display: grid;
  grid-template-columns: 1fr 1fr;

  span {
    margin-right: 10px;
    line-height: 1.1;
  }

}

.edit-patient {
  margin: 0 !important;

  .form-group {
    width: 45%;
  }
}

#modal-edit {
  .modal-body {
    padding: 0.8rem 4rem;
  }
}

.save-changes {
  width: 100%;
}

.name-wrapper input, .name-wrapper button {
  border: none !important;
  border-bottom: 1px solid #d8d6de !important;
  border-radius: 0;
}

.divider {
  text-align: left;
  margin: 0;

  .divider-text {
    padding: 0;
    font-size: 16px;
    font-weight: bold;
  }
}

.about-patient-container .infos.index-patients {
  grid-template-columns: 1fr;
  max-width: 35%;
}

.risk-factors-container {
  .responsibility-container {
    grid-template-columns: 1fr 1fr;

    .info-container {
      flex-direction: column;
    }
  }
}

.future-analysis {
  background-color: #F3F2F7;
}

.finished-treatment {
  .current-case {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .info-container {
    margin-right: 2vw;
    white-space: nowrap;
    align-items: center;
  }
}


.nav-pills > li {
  width: 33%;
}

.nav-pills {
  background-color: #FFFFFF;
  border: 1px solid #EBE9F1;
  padding: 7px;
  justify-content: space-around;
  border-radius: 12px;
}

</style>
